import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "bootstrap/dist/js/bootstrap.min.js";

import { Language } from "./common";
import logo from "../assets/images/logo.png";
import styles from "../assets/styles/header.module.scss";

interface IHeaderProps {
  isEnglish: boolean;
  handleLanguageClick: () => void;
}

export function Header(props: IHeaderProps) {
  const [scrolling, setScrolling] = useState(false);
  const { t, i18n } = useTranslation("common");
  const [isNavCollapsed, setIsNavCollapsed] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleScroll = () => {
    if (window.scrollY > 20) {
      setScrolling(true);
    } else {
      setScrolling(false);
    }
  };

  const handleNavCollapse = () => {
    setIsNavCollapsed(!isNavCollapsed);
  };

  return (
    <Navbar
      expand="lg"
      id="navbar"
      aria-expanded={isNavCollapsed}
      expanded={isNavCollapsed}
      className={`${styles.navbar} navbar  ${scrolling ? '' : 'navbar-dark'} fixed-top ${scrolling ? styles.navbarWhite : ''}`}
    >
      <div 
        className={`${styles.closeNavbarToggler} close-navbar-toggler ${isNavCollapsed ? 'collapsed vh-100' : 'h-0'}`}
        onClick={handleNavCollapse}>
      </div>

      <Container className="d-flex align-items-center justify-content-lg-between">
        <a href="." className="logo me-auto me-lg-0 order-1">
          <img className="img-fluid" height={34} width={50} src={logo} alt={t("redirectConventions")} />
        </a>

        <Navbar.Toggle
          data-toggle="collapse"
          data-target="#navbarCollapse"
          aria-controls="navbarCollapse"
          aria-expanded={!isNavCollapsed}
          aria-label="Toggle navigation"
          onClick={handleNavCollapse}
          className="order-2"
        />

        <Navbar.Collapse className="justify-content-end order-lg-3 order-md-4 order-sm-4 order-4" id="navbarCollapse" aria-expanded={!isNavCollapsed}>

          <Nav id="navbarCollapse" className="ms-auto text-uppercase align-items-center">
            <Nav.Link id={styles.navLink} href="#about">{t("about")}</Nav.Link>
            <Nav.Link id={styles.navLink} href="#specialities">{t("specialities")}</Nav.Link>
            <Nav.Link id={styles.navLink} href="#protocols">{t("protocols")}</Nav.Link>
            <Nav.Link id={styles.navLink} href="#contacts">{t("contacts")}</Nav.Link>
          </Nav>

        </Navbar.Collapse>

        <Language className="order-lg-4 order-md-3 order-sm-3 order-3" value={props.isEnglish ? "en" : "pt"} onClick={props.handleLanguageClick} />

      </Container>
    </Navbar>
  );
}
